// ============================================================================
// WORKER SCHEDULE (Part 5)
// Cleaner portal: schedule of assigned tasks, start task → checklist/inventory/maintenance
// Reuses CleanerDashboard UI (same schedule + start logic).
// ============================================================================

import CleanerDashboard from "@/pages/cleaner/CleanerDashboard";

const WorkerSchedule = () => <CleanerDashboard />;

export default WorkerSchedule;
